export const updateCategory = payload => ({
    type: "UPDATE_CATEGORY",
    payload,
});